<template>
    <div>
        <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
            <div class="box1" style="text-align: center;">
                <div style="overflow: hidden; margin: 40px auto;">
                    <div class="box4">账号管理</div>
                    <div class="box3">个人中心</div>
                    <div class="box3">个人信息</div>
                    <div class="box3">账户安全</div>
                    <div class="box3">收货地址</div>
                    <div class="box3">我的积分</div>
                    <div class="box3">我的收藏</div>
                    <div class="box3">我的足迹</div>
                    <div class="box3">消息通知</div>
                </div>
                <div style="overflow: hidden; margin: 40px auto;">
                    <div class="box4">主题管理</div>
                    <div class="box3">企业信息</div>
                    <div class="box3">我的资质</div>
                    <div class="box3">授信建档</div>
                </div>
                <div style="overflow: hidden; margin: 40px auto;">
                    <div class="box4">交易管理</div>
                    <div class="box3" style="border-left: 2px solid #2B9A34; color: #2B9A34;">我的订单</div>
                    <div class="box3">定制订单</div>
                    <div class="box3">发票管理</div>
                </div>
                <div style="overflow: hidden; margin: 40px auto;">
                    <div class="box4">服务中心</div>
                    <div class="box3">关于科隆</div>
                    <div class="box3">服务与支持</div>
                    <div class="box3">订购指南</div>
                    <div class="box3">参考资料</div>
                    <div class="box3">退换货流程说明</div>
                </div>
            </div>
            <div class="box5">
                <div style="overflow: hidden;">
                    <div class="box6" style="float: left;">我的订单</div>
                    <div style="float: right;">
                        <a-input-search placeholder="input search text" enter-button="查询" size="large" @search="onSearch" />
                    </div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 4%;">
                    <div class="head_items" :key="index" v-for="(item, index) in 9">全部订单</div>
                </div>

                <div style="width: 100%;height: 1px;border: 1px dashed #EEEEEE; margin-top: 4%;"></div>
                <div style="overflow: hidden;">
                    <div class="box6" style=" margin-top: 4%; overflow: hidden;">发票信息</div>
                    <div style="overflow: hidden; margin-top: 4%;">
                        <div class="zengzhishui">增值税普通发票</div>
                        <div class="zengzhishui" style="margin-left: 4%;">增值税专项发票</div>
                    </div>
                    <div style="width: 100%;height: 60px;background: #F4F4F4; margin-top: 4%;padding: 0 2%;">
                        <div class="fapiaotaitou">发票抬头：XXXXXXX <span style="margin-left: 40%;">统一社会信用代码：XXXXXXX</span></div>
                    </div>
                </div>

                <div style="width: 100%;height: 1px;border: 1px dashed #EEEEEE; margin-top: 4%;"></div>
                <div style="overflow: hidden;">
                    <div class="box6" style=" margin-top: 4%; overflow: hidden;">发票信息</div>
                    <div style="overflow: hidden; margin-top: 4%;">
                        <div class="zengzhishui">增值税普通发票</div>
                        <div class="zengzhishui" style="margin-left: 4%;">增值税专项发票</div>
                    </div>
                    <div style="width: 100%;height: 60px;background: #F4F4F4; margin-top: 4%;padding: 0 2%;">
                        <div class="fapiaotaitou">发票抬头：XXXXXXX <span style="margin-left: 40%;">统一社会信用代码：XXXXXXX</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'integral',
    data() {
        return {};
    },
    methods: {},
    created() {}
};
</script>

<style scoped>
.fapiaotaitou {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
}

.zengzhishui {
    width: 140px;
    height: 40px;
    border: 1px solid #2b9a34;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 40px;
    float: left;
}

.head_items {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: left;
    width: 11.111%;
    float: left;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 1023px;
    width: 80%;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/my_invoice.vue